import {
    PARTICIPANT_PATCH_FAILURE,
    PARTICIPANT_PATCH_REQUEST,
    PARTICIPANT_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const patchReducer = (state = initialState, action) => {
    const {type, participant} = action;
    switch (type) {
        case PARTICIPANT_PATCH_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            participant,
        }}

        case PARTICIPANT_PATCH_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case PARTICIPANT_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
